import { PartnerLedgerDashboard } from '../components/integration/PartnerLedgerPages';

interface UserInfo {
  username: string;
  displayName: string;
  role: string;
  orgName: string;
  orgIcon: string;
  loginTime: string;
}

export default function KAISTDashboard({ user }: { user: UserInfo }) {
  return <PartnerLedgerDashboard partner="KAIST" user={user} />;
}
